var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal-dialog modal-small", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              staticClass: "modal-header",
              staticStyle: { "border-bottom": "none" }
            },
            [
              _c("h5", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("message.areyousuretodeletethis")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  attrs: {
                    disabled: _vm.$store.state.app.loading,
                    type: "button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("button.close")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              [
                _vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { disabled: true, type: "button" }
                      },
                      [_c("i", { staticClass: "fas fa-spinner spin" })]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.del()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.delete")) +
                            "\n          "
                        )
                      ]
                    )
              ]
            ],
            2
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d69ae41", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d69ae41","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/modal/channelnoti/Delete.vue
// module id = null
// module chunks = 